module.exports = __webpack_public_path__ + "img/no_image.ee4dbe73.svg";